import {FC, Fragment, useEffect, useState} from 'react'
import {Col, Modal, Row} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import Skeleton from 'react-loading-skeleton'
import {fetchOutstandingSO} from 'src/services/fetcher'
import * as TableUI from 'src/components/Table/Table'
import { RowHead } from './modal-so/RowHead'
import { RowData } from './modal-so/RowData'
import { RowFilter } from './modal-so/RowFilter'
import { objToParams } from 'src/utils'
import axios from 'axios'
import Pagination from '../../component/Pagination'
import { soSelector } from 'src/redux/slices/soSlices'
import { useAppSelector } from 'src/redux/hooks'
import { useRowTable } from 'src/hooks/useRowTable'

type Prop = {
  isShow: boolean
  setShow: (p1: any) => void
  filter: Record<string, any>
}

export const ModalSO: FC<Prop> = ({isShow, setShow, filter}) => {
  const {t} = useTranslation()
  const { outstandingFilter } = useAppSelector(soSelector)

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])

  const [numberURL, setNumberURL] = useState([])
  const [soNum, setSoNum] = useState<any[]>([])

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 7,
    onReloadTable: () => {
      loadData()
    },
  })

  const loadData = async () => {
    setLoading(true)
    try {
      const {data} = await fetchOutstandingSO({
        ...filter,
        ...outstandingFilter
      })
      setData(data.data.data)
      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  useEffect(() => {
    loadData()
  }, [filter, outstandingFilter])

  const paginateNumber = async (number: any) => {
    let params = objToParams({
        ...filter
    })

    const res = await axios.get(
      `${number}&credentials=${localStorage.getItem(
        'credential'
      )}&${params}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    setSoNum(res.data.data.data)
    setNumberURL(res.data.data.links)
  }

  return (
    <>
      <Modal
        show={isShow}
        onHide={() => setShow(false)}
        centered
        size='xl'
        backdrop='static'
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('outstanding-so')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Fragment>
            <TableUI.TableWrapper style={{marginBottom: '1rem'}}>
              <TableUI.Table>
                <TableUI.THead>
                  <RowHead />
                </TableUI.THead>

                <TableUI.TBody>
                  <RowFilter />
                  {
                    loading ? <RowLoader />
                    : (data.length ? <RowData data={data}/> : <RowEmptyData/>)
                  }
                </TableUI.TBody>
              </TableUI.Table>
            </TableUI.TableWrapper>

            <Pagination paginate={paginateNumber} test={numberURL} />
          </Fragment>
        </Modal.Body>
      </Modal>
    </>
  )
}
